// src/components/vault/ui/VaultLayout.tsx
import React from "react";
import { MotionConfig } from "motion/react";

interface VaultLayoutProps {
  sidebar: React.ReactNode;
  topNav: React.ReactNode;
  content: React.ReactNode;
  logo?: React.ReactNode;
  mobileBottomBar?: React.ReactNode;
  mobileStepSheet?: React.ReactNode;
  /** Ref to the scrollable content container (for scroll-to-top on tab change) */
  contentScrollRef?: React.RefObject<HTMLDivElement | null>;
}

export function VaultLayout({
  sidebar,
  topNav,
  content,
  logo,
  mobileBottomBar,
  mobileStepSheet,
  contentScrollRef,
}: VaultLayoutProps) {
  return (
    <MotionConfig reducedMotion="user">
      <div className="h-screen w-full bg-white overflow-hidden">
        <div className="flex h-full">
          {/* Left Sidebar — no initial animation to avoid flash after skeleton */}
          <aside className="hidden lg:flex w-80 flex-col border-r border-slate-100 bg-slate-50/80">
            {/* Logo area */}
            {logo && (
              <div className="px-6 pt-5 pb-4 [&_img]:max-h-[72px] [&_img]:w-auto">
                {logo}
              </div>
            )}
            {/* Sidebar content */}
            <div className="flex-1 overflow-hidden">
              {sidebar}
            </div>
          </aside>

          {/* Main content area */}
          <main className="flex-1 flex flex-col overflow-hidden bg-white">
            {/* Top Navigation */}
            <header className="flex-shrink-0 border-b border-slate-100 bg-white">
              {topNav}
            </header>

            {/* Content area — appears instantly after skeleton, no opacity delay */}
            <div ref={contentScrollRef} className="flex-1 overflow-y-auto">
              <div className="w-full max-w-5xl mx-auto px-4 py-6 sm:px-6 lg:px-8 pb-[calc(var(--mobile-bottom-bar-height)+var(--mobile-safe-area-bottom)+16px)] lg:pb-8 [scroll-padding-bottom:calc(var(--mobile-bottom-bar-height)+var(--mobile-safe-area-bottom)+16px)] lg:[scroll-padding-bottom:0]">
                {content}
              </div>
            </div>

            {/* Mobile step sheet overlay */}
            {mobileStepSheet}

            {/* Mobile bottom navigation */}
            {mobileBottomBar}
          </main>
        </div>
      </div>
    </MotionConfig>
  );
}

